import React from "react";
import { Grid } from "@mui/material";
import { Input } from "components/haven-design/form/inputs";
import styles from "./batchActions.module.css";

export type AddNoteStateValues = {
  note: string;
}

type Props = {
  isLoading: boolean;
  onChange(data: AddNoteStateValues) : void;
  isShowing: boolean;
  fieldErrors: { note: string };
}

const NoteForm: React.FC<Props> = (props) => {
  const [note, setNote] = React.useState<string>("");
  return (
    <div className={props.isShowing ? "" : styles.hideView} style={{ width: "100%" }}>
      <Grid size={{ xs: 12 }}>
        <form
          id="activityForm"
          onSubmit={(e) => e.preventDefault()}
          className={props.isShowing ? "" : styles.hideView}>

          <div className={styles.actionViewLabel}>Add a Note</div>

          <div>
            <Input
              name="reason"
              label="Reason"
              multiline
              required
              error={Boolean(props.fieldErrors.note)}
              helperText={props.fieldErrors.note}
              onChange={({ target: { value } }) => {
                setNote(value);
                props.onChange({ note: value });
              }}
              value={note}
            />
          </div>
        </form>
      </Grid>
    </div>
  );
};
export default NoteForm;
